import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {gsap} from "gsap";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreeSpinsOutro implements SimplePresentation {

    name:string = "FreesSpinIntro";

    constructor() {

    }

    public shouldRun():boolean {
        //return //!NineToFive.model.gameData.brokeTheBank &&
        return !NineToFive.model.data.brokeTheBank &&
               NineToFive.model.data.nextMode == GameMode.NORMAL &&
               (NineToFive.model.data.mode == GameMode.FREESPIN || NineToFive.model.data.mode == GameMode.FREESPIN_SUPER);
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        tl.add(() => {controller.setSkipCallback(() => {tl.seek("end", false)})});
        tl.add(() => {
            //NineToFive.keypadPlugin.hide()
            NineToFive.keypadPlugin.setZeroBetSpinCounter(-1);
            if (!NineToFive.isWinBelowStake()) {
                NineToFive.soundPlayer.playSound("fsOutroOneShot");
                NineToFive.soundPlayer.playLoopingSound("fsOutroLoop");
            }
        });
        if (NineToFive.model.data.mode == GameMode.FREESPIN) {
            tl.add(NineToFive.transitionScreen.showOutro(), '<');
        } else {
            tl.add(NineToFive.transitionScreen.showOutroSuper(), '<');
        }
        tl.add(() => {
            NineToFive.soundPlayer.fadeOutMusic();
        }, '<');
        tl.add(() => {
            NineToFive.keypadPlugin.setWin(NineToFive.model.gameData.accumulatedRoundWin, true, NineToFive.isWinBelowStake());
        });
        tl.addLabel("end");
        tl.add(() => {controller.setSkipCallback()})
        if (!NineToFive.model.data.brokeTheBank) {
            tl.add(NineToFive.transitionScreen.enableButton(() => this.onButtonClick(controller)));
        } else {
            tl.add(() => controller.finish(), '>1');
        }
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            NineToFive.keypadPlugin.show();
            NineToFive.soundPlayer.stopSound("fsOutroLoop");
            NineToFive.baseGameReelView.setBaseReelSet();
            if (NineToFive.model.isBoostedBet()) {
                NineToFive.baseGameReelView.enableXBetReel(false);
            }
        });

        // TODO maybe put into a method for consistencys sake
        tl.add(() => {NineToFive.baseGameReelView.freespinMultiplier.visible = false});
        tl.add(NineToFive.backgroundElements.setToBaseGame());
        if (NineToFive.model.data.mode == GameMode.FREESPIN) {
            tl.add(NineToFive.transitionScreen.hideOutro(), '<');
        } else {
            tl.add(NineToFive.transitionScreen.hideOutroSuper(), '<');
        }
        tl.add(() => {NineToFive.soundPlayer.switchMusic(GameMode.NORMAL)}, '<')
        tl.add(() => NineToFive.soundPlayer.fadeInMusic(), '<');

        tl.add(() => {
            NineToFive.xBetView.removeButton(true);
            //NineToFive.popUpView.showPopUp();
        },'<');
        tl.add(() => controller.finish());

    }
}